import Intreact from './src/intreact.jsx';

export default Intreact;



/** WEBPACK FOOTER **
 ** ./index.js
 **/